module.exports = __webpack_public_path__ + "img/gold2.bbb5d005.gif";